export const UPDATE_SUPPORT = "UPDATE_SUPPORT"

export const SEND_SUPPORT = "SEND_SUPPORT"
export const SEND_SUPPORT_PENDING = "SEND_SUPPORT_PENDING"
export const SEND_SUPPORT_FULFILLED = "SEND_SUPPORT_FULFILLED"
export const SEND_SUPPORT_FAILED = "SEND_SUPPORT_REJECTED"
